import {
  saveOnboardingData,
  getOnboardingData,
  clearOnboardingData,
  determineOnboardingStep,
} from "@/utils/onboarding-storage";

const createOnboardingStore = (set, get) => ({
  // State
  onboardingData: null,

  // Initialize onboarding data from storage
  initializeOnboarding: () => {
    if (typeof window === "undefined") return;

    const savedData = getOnboardingData();
    if (savedData) {
      set({ onboardingData: savedData });
      console.log(
        "Initialized onboarding data with step:",
        savedData.currentStep
      );
    }
  },

  // Update onboarding data
  updateOnboardingData: (data) => {
    if (typeof window === "undefined") return;

    const currentData = get().onboardingData || {};

    // Merge current data with new data
    const newData = { ...currentData, ...data };

    // Save to storage
    saveOnboardingData(newData);

    // Update store
    set({ onboardingData: newData });
  },

  // Clear onboarding data
  clearOnboardingData: () => {
    if (typeof window === "undefined") return;

    // Clear from storage
    clearOnboardingData();

    // Clear from store
    set({ onboardingData: null });
  },

  // Get onboarding data
  getOnboardingData: () => {
    // First try to get from store
    const storeData = get().onboardingData;
    if (storeData) return storeData;

    // If not in store, try to get from storage
    if (typeof window !== "undefined") {
      return getOnboardingData();
    }

    return null;
  },

  // Determine step based on current data
  determineOnboardingStep: () => {
    const data = get().getOnboardingData();
    return determineOnboardingStep(data);
  },
});

export default createOnboardingStore;
